import * as actionTypes from "./actionTypes";
export const providerBills = (providerBills) => {
  return {
    type: actionTypes.PROVIDER_BILLS,
    providerBills: providerBills,
  };
};
export const patientsResponsibilityBills = (patientsResponsibilityBills) => {
  return {
    type: actionTypes.PATIENTS_RESPONSIBILITY_BILLS,
    patientsResponsibilityBills: patientsResponsibilityBills,
  };
};
export const explanationOfBenefitsBills = (explanationOfBenefitsBills) => {
  return {
    type: actionTypes.EXPLANATION_OF_BENEFITS_BILLS,
    explanationOfBenefitsBills: explanationOfBenefitsBills,
  };
};

export const collectionNoticeBills = (collectionNoticeBills) => {
  return {
    type: actionTypes.COLLECTION_NOTICE_BILLS,
    collectionNoticeBills: collectionNoticeBills,
  };
};
export const subsequentProviderBills = (subsequentProviderBills) => {
  return {
    type: actionTypes.SUBSEQUENT_PROVIDER_BILLS,
    subsequentProviderBills: subsequentProviderBills,
  };
};
